import { render } from "./IconAlert.vue?vue&type=template&id=5daa17e2"
const script = {}

import exportComponent from "/home/balluff-sales-app-stagelinksderi/sales-app.stage.balluff.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__